import { request } from '../request'

/**
 * 获取电话访问任务列表
 * @param id 问卷ID
 * @param params
 * @return {Promise}
 */
export const getPhoneList = params => {
  return request({
    url: '/quota/surveyJobExecution/phoneList/',
    method: 'get',
    params: params
  })
}
/**
 * 创建电话访问任务
 * @param data
 * @return {Promise}
 */
export const creatPhoneTask = params => {
  return request({
    url: '/quota/surveyJobExecution/addPhoneList',
    method: 'post',
    data: params
  })
}

/**
 * 查询电话访问任务
 * @param id 任务ID
 * @return {Promise}
 */
export const getPhoneTask = id => {
  return request.get('/quota/surveyJobExecution/phoneJob/' + id)
}

/**
 * 编辑任务
 * @param data
 * @return {void|AxiosPromise<any>|IDBRequest<IDBValidKey>|Promise<void>}
 */
export const putTask = data => {
  return request.put('/quota/surveyJobExecution', data)
}
/**
 * 任务开关
 */
export const putTaskSwitch = data => {
  return request.put('/quota/surveyJobExecution/batchOpenOrClose', data)
}
//查询外呼状态列表
export const phoneStatusList = params => {
  return request({
    url: '/quota/surveyJobExecution/phoneStatusList',
    method: 'get',
    params: params
  })
}

//查询外呼状态列表
export const exportPhoneExcel = params => {
  return request({
    url: '/quota/surveyJobExecution/exportPhoneExcel',
    method: 'get',
    params: params,
    responseType: 'blob'
  })
}

// 原有电话任务增加号码
export function updatePhoneList(data) {
  return request({
    url: '/quota/surveyJobExecution/updatePhoneList',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

// 检查电话任务电话是否在问卷中重复
export function checkPhoneList(data) {
  return request({
    url: '/quota/surveyJobExecution/checkPhoneList',
    method: 'POST',
    headers: {
      'Content-type': 'application/json'
    },
    data
  })
}

// 查询电话任务excel导出
export const phoneListExcel = params => {
  return request({
    url: '/quota/surveyJobExecution/phoneListExcel',
    method: 'get',
    params: params
  })
}

// 查询问卷预测式外呼状态
export const getPredictCallStatus = params => {
  return request({
    url: '/quota/surveyJobExecution/surveyPredictCallStatus',
    method: 'get',
    params: params
  })
}

// 修改问卷预测式外呼状态
export const changePredictCallStatus = params => {
  return request({
    url: '/quota/surveyJobExecution/changeSurveyPredictCallStatus',
    method: 'post',
    data: params
  })
}